<template>
  <div class="headercart__list" v-if="template === 'cart'">
    <div v-for="cart in products" class="headercart__item active">
      <div class="headercart__item-img">
         <TheProductImage :product="cart.product" :size="ProductImageType.SMALL" />
      </div>
      <div class="headercart__item-row">
        <div class="headercart__item-left">
          <div class="headercart__item-name">{{ cart.product.name }}
            <div class="cart__item-option" >
              <!-- <span v-for="(option,index) in cart.option"><b> {{ (index > 0 && index < cart.option.length )? ', ':'' }} {{ option.name }}<span v-if="option.type === 'select'">: {{option.value}}</span></b></span> -->
            </div>
          </div>

          <TheProductPlusAndMinusBox :product="cart.product" :cart="cart" :show-in-center-price="false"/>
        </div>
        <div class="headercart__item-right">
          <div v-if="!cart || cart.modifiable === true" class="headercart__item-delete" @click="removeProduct(cart.cart_id)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 6L18 18M18 6L6 18" stroke="#808183" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
          </div>
          <div class="headercart__item-price">{{ cart.total }}</div>
        </div>
      </div>
    </div>
  </div>

  <div v-else  v-for="cart in products"  class="cart__list-item active">
    <div class="cart__item-img">
      <TheProductImage
        :style="{ cursor: 'pointer' }"
        :product="cart.product"
        :size="ProductImageType.MEDIUM"
        @click="showProductModal(cart.product)"
      />
    </div>
    <div class="cart__item-info">
      <ComboTag :product-id="cart.product.product_id" :style="{ position: 'static' }" />
      <div class="cart__item-row">
        <div class="cart__item-left" :style="{ cursor: 'pointer' }" @click="showProductModal(cart.product)">
          <div class="cart__item-title">{{ cart.product.name }}</div>
          <div class="cart__item-price" v-once v-if="cart.product.price > 0">{{ cart.product.price  }}</div>
          <div class="cart__item-option">
            <span v-for="(option,index) in cart.option"><b> {{ (index > 0 && index < cart.option.length )? ', ':'' }} {{ option.name }}<span v-if="option.type === 'select'">: {{option.value}}</span></b></span>
          </div>
        </div>
        <div class="cart__item-right">
          <TheProductPlusAndMinusBox :product="cart.product" :cart="cart" :show-in-center-price="false"/>
          <div class="cart__item-summ">{{ cart.total }}</div>
          <div v-if="!cart || cart.modifiable === true" class="cart__item-delete" @click="removeProduct(cart.cart_id)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                              xmlns="http://www.w3.org/2000/svg">
            <path d="M6 6L18 18M18 6L6 18" stroke="#808183" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
          </svg>
          </div>
          <div v-else class="cart__item-delete">

          </div>
        </div>
      </div>
    </div>
  </div>


  <div  v-if="template === 'order'" v-for="product in removed_stop_list" class="cart__list-item removed_stop_list active">
    <div   class="cart__item-img" style="opacity: 0.3">
      <TheProductImage :product="product" :size="ProductImageType.MEDIUM" />
    </div>
    <div class="cart__item-info">
      <ComboTag :product-id="product.product_id" :style="{ position: 'static' }" />

      <div class="cart__item-row">
        <div class="cart__item-left">
          <div class="cart__item-title" style="opacity: 0.3">{{ product.name }}</div>
          <div class="cart__item-price" style="opacity: 0.3">{{ product.price }}</div>
          <div class="cart__item-option" style="opacity: 0.3">{{ product.description }}</div>
          <div class="cart__item-option" style="color: #D92121; opacity: 1">Недоступно по данному адресу</div>
        </div>
        <div class="cart__item-right" style="opacity: 0.3">
          <div class="cart__item-summ">{{ product.price }}</div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import TheProductImage from "@/components/element/TheProductImage.vue";
import ProductImageType from "@/enum/ProductImageType.js";
import TheProductPlusAndMinusBox from "@/components/element/TheProductPlusAndMinusBox.vue";
import ProductTemplateType from "@/enum/ProductTemplateType.js";
import ComboTag from '@/components/element/ComboTag.vue';

export default {
  name: 'TheMiniCartProductList',
  components: {TheProductPlusAndMinusBox, TheProductImage, ComboTag},
  computed: {
    ProductImageType() {
      return ProductImageType
    },
    ...mapState({
      'products': state => state.cart.products,
      'removed_stop_list': state => state.cart.removed_stop_list,
    }),
  },
  props: {
    template: {
      default: 'cart',
    },
  },
  methods:{
    ...mapMutations({
      'showProductModal': 'productModal/showProductModal',
    }),
    ...mapActions({
      'remove': 'cart/remove',
    }),
    removeProduct(cart_id){
      this.remove(cart_id)
    }
  }
}
</script>

